import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8de7e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setup-address" }
const _hoisted_2 = { class: "tabs flex" }
const _hoisted_3 = ["onClick"]

import { ref } from 'vue'
import AddressTable from './components/AddressTable.vue'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tabs = [
  { label: t('收货地址'), name: 'take' },
  { label: t('清关地址'), name: 'clear' }
].fort()
const cur = ref(0)

const jump = (i: number) => {
  cur.value = i
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (v, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.label,
          class: "fx-1"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["btn", { active: cur.value === i }]),
            onClick: ($event: any) => (jump(i))
          }, _toDisplayString(v.label), 11, _hoisted_3)
        ]))
      }), 128))
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(AddressTable, {
          class: "mt_20",
          name: _unref(tabs)[cur.value].name
        }, null, 8, ["name"])
      ]),
      _: 1
    }))
  ]))
}
}

})